import { Dispatch } from 'redux';
import { ActionTypes, ReduxAction } from './types';
import { MautberechnungParam, MautService } from '../../api';

export const getMautLaender = () => async (dispatch: Dispatch<ReduxAction>) => {
  new MautService().getAllLaender().then(response => {
    dispatch({
      type: ActionTypes.GET_LAENDER_MAUT,
      payload: response.data,
    });
  });
};

export const mautBerechnung =
  (
    abgLKZ: string,
    abgPlz: string,
    empLKZ: string,
    empPlz: string,
    gewicht: string
  ) =>
  async (dispatch: Dispatch<ReduxAction>) => {
    const maut: MautberechnungParam = {
      abgangLKZ: abgLKZ,
      abgangPlz: abgPlz,
      empfaengerLKZ: empLKZ,
      empfaengerPlz: empPlz,
      gewicht: gewicht,
    };
    new MautService().getMaut(maut).then(response => {
      dispatch({
        type: ActionTypes.GET_MAUT,
        payload: response.data,
        anfrageGestartet: false,
      });
    });
  };

export const setAnfrageGestartet =
  (anfrage: boolean) =>
  (dispatchEvent: Dispatch<ReduxAction>): void => {
    dispatchEvent({
      type: ActionTypes.ANFRAGE_GESTARTET,
      payload: anfrage,
    });
  };
